import React from 'react'
import useClientLocation from '../../../hooks/use-client-location'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import { Dropdown } from 'react-bootstrap'

const ViewButton = ({
    itemId
}) => {
    const { toLocation } = useClientLocation()

    return (
        <Dropdown.Item
            onClick={ () => toLocation(CLIENT_ENDPOINTS.REFLECTION_PROMPT.replace(':reflectionPromptId', itemId))}
        >
            Edit
        </Dropdown.Item>
    )
}

export default ViewButton